import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { DrawingThumbnail } from '../../components/DrawingThumbnail';
import { publicDrawingPath } from './publicAccess';

interface PublicDrawingCardProps {
  readonly drawingId: string;
  readonly title: string | null;
  readonly updatedAt?: string | null | undefined;
  /** Omitted for search results, which don't carry it; null when none has been recorded. */
  readonly authorName?: string | null | undefined;
}

/** #885: one public drawing in the browse grid or search results -- links to its page. */
export function PublicDrawingCard({ drawingId, title, updatedAt, authorName }: PublicDrawingCardProps) {
  const { t } = useTranslation();
  return (
    <li className="public-drawing-card">
      <Link to={publicDrawingPath(drawingId)}>
        <span className="public-drawing-card-thumb">
          <DrawingThumbnail drawingId={drawingId} version={updatedAt ?? undefined} ink="paper" fill />
        </span>
        <span className="public-drawing-card-title">{title || t('publicPages.untitled')}</span>
        {authorName !== undefined ? (
          <span className="public-drawing-card-author">
            {t('publicPages.byAuthor', { author: authorName || t('publicPages.unknownAuthor') })}
          </span>
        ) : null}
      </Link>
    </li>
  );
}
